module.exports = __webpack_public_path__ + "static/media/heatingInstructions250120-1.cd4c2792.jpg";